import Layout from './layout'

export default [
  {
    path: '/distribution-manage',
    component: Layout,
    meta: { title: '分销管理', icon: 'distribution', groupTitle: '通用', roles: ['taoke'] },
    name: 'DistributionManage',
    redirect: 'commission',
    alwaysShow: true,
    children: [
      {
        path: 'commission',
        component: () => import(/* webpackChunkName: "commission" */ '@v/distributionManage/commission'),
        name: 'DistributionManageCommission',
        meta: { title: '佣金设置' },
      },
      // {
      //   path: 'request',
      //   component: () => import(/* webpackChunkName: "commission" */ '@v/distributionManage/request'),
      //   name: 'DistributionManageRequest',
      //   meta: { title: '代理申请' },
      // },
    ],
  },
]